import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const CloseButton = styled(Box)`
  ${() => css`
    cursor: pointer;
    position: absolute;
    top: 16px;
    right: 16px;
  `}
`

export const ToastContent = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`

export const IconWrapper = styled(Box)<{ type?: 'success' | 'error' | 'warning' }>`
  ${({ theme, type }) => {
    const iconColor =
      type === 'success'
        ? theme.colors.green.color
        : type === 'warning'
          ? theme.colors.orange.color
          : theme.colors.red.color
    return css`
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      width: 40px;
      height: 40px;
      color: ${iconColor};

      svg path[stroke] {
        stroke: ${iconColor} !important;
      }

      svg path[fill] {
        fill: ${iconColor} !important;
      }
    `
  }}
`

export const TextWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`

export const ToastTitle = styled(Box)`
  ${({ theme }) => css`
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    color: ${theme.colors.lightest};
  `}
`

export const ToastMessage = styled(Box)<{ type?: 'success' | 'error' | 'warning' }>`
  ${({ theme, type }) => css`
    font-size: 16px;
    line-height: 16px;
    font-weight: 700;
    color: ${type === 'success'
      ? theme.colors.green.color
      : type === 'warning'
        ? theme.colors.orange.color
        : theme.colors.red.color};
  `}
`
